import { useState, useEffect, useCallback } from 'react';
import { supabase } from '../lib/supabase';

export function useSites(orgId) {
  const [sites, setSites] = useState([]);
  const [loading, setLoading] = useState(true);

  const loadSites = useCallback(async () => {
    if (!orgId) return;
    const { data } = await supabase.from('sites').select('*').eq('org_id', orgId).order('name');
    setSites(data || []);
    setLoading(false);
  }, [orgId]);

  useEffect(() => {
    if (orgId) loadSites();
  }, [orgId, loadSites]);

  async function addSite(name, address) {
    const { error } = await supabase.from('sites').insert({ org_id: orgId, name, address: address || null });
    if (error) throw error;
    await loadSites();
  }

  async function updateSite(id, updates) {
    const { error } = await supabase.from('sites').update(updates).eq('id', id);
    if (error) throw error;
    await loadSites();
  }

  async function deleteSite(id) {
    // Clear site_id from any profiles using this site
    await supabase.from('profiles').update({ site_id: null }).eq('site_id', id);
    const { error } = await supabase.from('sites').delete().eq('id', id);
    if (error) throw error;
    await loadSites();
  }

  function getSiteName(siteId) {
    if (!siteId) return null;
    return sites.find(s => s.id === siteId)?.name || null;
  }

  return { sites, loading, addSite, updateSite, deleteSite, getSiteName, reload: loadSites };
}
